export default {
	lock_screen(){
		var aContainer = document.createElement('div');
		aContainer.setAttribute('id', 'nse-loading-lock-window');
		document.body.appendChild(aContainer);
	},

	remove_lock_screen(){
		const lockOverlay = document.getElementById('nse-loading-lock-window');
		if (lockOverlay) {
			lockOverlay.remove();
		}
	},
}
